import { type CSSProperties } from 'react';
import { CheckBoldIcon } from '@zep-us/zus-icons';
import type { AvatarShapePart } from '@/shared/features/user-avatar';
import { cn } from '@/utils';
export const AvatarColorPicker = ({
  colors,
  selectedColorIndex,
  onSelect
}: {
  colors: AvatarShapePart[];
  selectedColorIndex: number;
  onSelect: (index: number) => void;
}) => {
  return <div className="flex w-full items-center gap-2xs overflow-x-auto px-sm py-sm mobile-lg:gap-2xs mobile-lg:pb-md mobile-lg:pt-sm" data-sentry-component="AvatarColorPicker" data-sentry-source-file="AvatarColorPicker.tsx">
      {colors.map((part, index) => {
      const isActive = selectedColorIndex === index;
      const noColor = part.hex === null;
      return <button key={part.partId} type="button" onClick={() => onSelect(index)} className={cn('group flex size-[32px] shrink-0 items-center justify-center rounded-[12px] p-[2px]', isActive ? 'ring-2 ring-[#a49bff]' : 'ring-0')}>
            <span style={{
          '--item-color': part.hex ?? '#CCCCCC'
        } as CSSProperties} className={cn('flex size-[28px] items-center justify-center rounded-[11px] border border-black/[0.12]', !noColor && 'bg-[var(--item-color)]', noColor && 'bg-[repeating-linear-gradient(45deg,theme(colors.gray.100)_0,theme(colors.gray.100)_4px,#fff_4px,#fff_8px)]', !isActive && 'group-hover:opacity-[0.72]')}>
              {isActive && <CheckBoldIcon size="2xs" className="text-inverse" />}
            </span>
          </button>;
    })}
    </div>;
};